import { render } from "./AddProjectModal.vue?vue&type=template&id=0d994194&scoped=true&ts=true"
import script from "./AddProjectModal.vue?vue&type=script&lang=ts"
export * from "./AddProjectModal.vue?vue&type=script&lang=ts"

import "./AddProjectModal.vue?vue&type=style&index=0&id=0d994194&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d994194"]])

export default __exports__